import React from "react";

interface EmptyStateProps {
  title: string;
  description: string;
  centerDescription?: boolean;
}

export const EmptyState = ({ title, description, centerDescription = false }: EmptyStateProps) => {
  return (
    <div className="grow flex flex-col justify-center items-center">
      <span className="text-2xl text-slate-700 dark:text-slate-100 font-bold mb-2">{title}</span>
      <div className={`mb-6 ${centerDescription ? "text-center" : ""}`}>{description}</div>
    </div>
  );
};
